var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg004Cctv = function Svg004Cctv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421 317c0-51.579-37.236-157.522-150-166.156V90h30V30h90V0H121v30h90v60h30v60.844C128.236 159.478 91 265.421 91 317v15h330zM256 512c83.275 0 121.542-73.385 131.902-150H124.098c10.36 76.615 48.627 150 131.902 150m0-120c24.814 0 45 20.186 45 45s-20.186 45-45 45-45-20.186-45-45 20.186-45 45-45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 437,
    r: 15
  })));
};
export default Svg004Cctv;